import React, { useState } from 'react';
import ModalV1 from '../modal-v1/index';
import SalesNav from '../../sales-terminal/records/sales-nav';
import AddCustomer from '../../sales-terminal/records/add-customer';
import { CartItems } from '../../sales-terminal/records/cart-items';
import ActionButtons from '../../sales-terminal/records/action-btns';
import EmptyInCart from '../../sales-terminal/records/empty-incart';
import { useGetCart, useGetParkedCart } from '../../../integrations/react_query/queries';
import { ECart, EQuerykeys } from '../../../models';
import CartBreakdownMobile from '../cart-breakdown-mobile/index';
import { RetrieveSaleModal, ParkSaleModal, DiscardSaleModal } from '../modals-mobile/index';

type CartModalProps = {
	show: boolean;
	onClose: () => void;
};

const CartModal = ({ show, onClose }: CartModalProps) => {
	const [showRetrieveModal, setShowRetrieveModal] = useState(false);
	const [showParkModal, setShowParkModal] = useState(false);
	const [showDiscardModal, setShowDiscardModal] = useState(false);

	const { isLoading, isError, error, data } = useGetCart([EQuerykeys.cart, ECart.active]);
	const { data: parkedCartData } = useGetParkedCart([EQuerykeys.cart, ECart.parked]);

	const cartItemsCount = data?.products?.length || 0;

	const salesNavProps = {
		onRetrieve: () => setShowRetrieveModal(true),
		onPark: () => setShowParkModal(true),
		onDiscard: () => setShowDiscardModal(true),
	};

	return (
		<>
			<ModalV1
				classes={{ content: 'min-h-[calc(100vh_-_70px)]' }}
				show={show}
				onClose={onClose}
				headerAction={<div className="text-base font-semibold text-gray-900">Cart ({cartItemsCount})</div>}
			>
				<div className="flex flex-col px-5">
					<SalesNav {...salesNavProps} />

					<AddCustomer />

					<div className="flex-1 overflow-y-auto pb-[200px]">
						{isLoading ? (
							<section className="flex items-center justify-center">
								<span className="text-gray-500">Pulling up data</span>
							</section>
						) : error || isError ? (
							<div className="flex items-center justify-center p-4 text-red-500">Something went wrong.</div>
						) : !data?.products?.length ? (
							<EmptyInCart />
						) : (
							<CartItems {...{ data }} />
						)}
					</div>
				</div>

				<CartBreakdownMobile />
			</ModalV1>

			{/* Mobile Modals */}
			<RetrieveSaleModal show={showRetrieveModal} onClose={() => setShowRetrieveModal(false)} />

			<ParkSaleModal show={showParkModal} onClose={() => setShowParkModal(false)} />

			<DiscardSaleModal show={showDiscardModal} onClose={() => setShowDiscardModal(false)} />
		</>
	);
};

export default CartModal;
